import { BillTypeEnum, ContractorTypeEnum } from "@gtpl/shared-models/common-models"

export class BillGenerationReportRequest {
    contractorId ?:number
    month?:number
    year?:number
    billType?:BillTypeEnum
    contractorType?:ContractorTypeEnum
    
     constructor(contractorId ?:number,month?:number,year?:number,billType?:BillTypeEnum,contractorType?:ContractorTypeEnum) {
         this.contractorId = contractorId
         this.month = month
         this.year = year
         this.billType = billType
         this.contractorType = contractorType
     }
 }
 